import { Role } from '../components/admin/roles/store/types';
import { api } from './services';

export const upsertRole = async (reqBody: Role) => await api('users/role/upsert', { ...reqBody }, 'post');
export const getAllRoles = async (reqBody: { clientId: number | undefined }) => await api('users/role/getAll', { ...reqBody }, 'post');
export const deleteRole = async (reqBody: { roleId: number }) => await api('users/role/delete', { ...reqBody }, 'post');
